import React from 'react';
import Icon from '../../../components/AppIcon';

const statusConfig = {
  'In Progress': { color: 'text-blue-500', bg: 'bg-blue-500', dot: 'bg-blue-500' },
  'Planning': { color: 'text-amber-500', bg: 'bg-amber-500', dot: 'bg-amber-500' },
  'On Hold': { color: 'text-orange-500', bg: 'bg-orange-500', dot: 'bg-orange-500' },
  'Completed': { color: 'text-emerald-500', bg: 'bg-emerald-500', dot: 'bg-emerald-500' },
};

const ProjectRow = ({ project }) => {
  const status = statusConfig?.[project?.status] || statusConfig?.['Planning'];
  const progress = project?.progress ?? 0;

  return (
    <div className="flex flex-col gap-2 py-3 border-b border-border last:border-0">
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground truncate">{project?.name || 'Unnamed Project'}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{project?.customer_name || project?.location || 'No details'}</p>
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          <span className={`w-2 h-2 rounded-full ${status?.dot}`} />
          <span className={`text-xs font-medium ${status?.color}`}>{project?.status}</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full ${status?.bg} transition-all duration-500`}
            style={{ width: `${Math.min(progress, 100)}%` }}
          />
        </div>
        <span className="text-xs font-medium text-muted-foreground w-8 text-right">{progress}%</span>
      </div>
    </div>
  );
};

const ActiveProjectsList = ({ projects, loading }) => {
  if (loading) {
    return (
      <div className="bg-card border border-border rounded-2xl p-4">
        <div className="h-5 bg-muted rounded w-32 mb-4 animate-pulse" />
        {[1, 2, 3]?.map(i => (
          <div key={i} className="py-3 border-b border-border last:border-0 animate-pulse">
            <div className="h-4 bg-muted rounded w-3/4 mb-2" />
            <div className="h-2 bg-muted rounded w-full" />
          </div>
        ))}
      </div>
    );
  }

  const activeProjects = projects?.filter(p =>
    p?.status === 'In Progress' || p?.status === 'Planning'
  )?.slice(0, 5);

  return (
    <div className="bg-card border border-border rounded-2xl p-4">
      <div className="flex items-center justify-between mb-1">
        <h2 className="text-base font-bold text-foreground">Active Projects</h2>
        <span className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full">
          {activeProjects?.length} active
        </span>
      </div>
      {activeProjects?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <Icon name="Briefcase" size={32} className="text-muted-foreground mb-2" />
          <p className="text-sm text-muted-foreground">No active projects</p>
        </div>
      ) : (
        <div>
          {activeProjects?.map(project => (
            <ProjectRow key={project?.id} project={project} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ActiveProjectsList;
